import * as React from 'react';
import { useSelector } from 'react-redux';

import { usePreciseFilters } from '../../containers/PreciseFiltersContainer/utils';
import { selectEstimationByDealType } from '../../selectors/estimation';
import { selectEstimationChartState } from '../../selectors/estimationChart';
import { selectHouseInfo } from '../../selectors/houseInfo';
import { selectOffersHistoryExists, selectOffersHistorySpoilerData } from '../../selectors/offersHistory';
import { selectDealType, selectIsDesktop } from '../../selectors/page';
import { EBlockName, trackExistBlock } from './tracking';

export function useSendBlocksExists() {
  const isDesktop = useSelector(selectIsDesktop);

  const { data: houseInfo } = useSelector(selectHouseInfo);
  const { data: estimationHistoryData } = useSelector(selectEstimationChartState);
  const { data: offersHistorySpoilerData } = useSelector(selectOffersHistorySpoilerData);
  const offersHistoryExistsForMobWeb = useSelector(selectOffersHistoryExists);
  const preciseFiltersData = usePreciseFilters();
  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));

  const offersHistoryExists = isDesktop
    ? offersHistorySpoilerData?.offers && offersHistorySpoilerData.offers.length > 0
    : offersHistoryExistsForMobWeb;

  return React.useCallback(() => {
    trackExistBlock(Boolean(houseInfo), EBlockName.AboutHouse);
    trackExistBlock(Boolean(estimationHistoryData), EBlockName.EstimationHistory);
    trackExistBlock(Boolean(offersHistoryExists), EBlockName.OffersHistory);
    trackExistBlock(Boolean(preciseFiltersData && estimation.data), EBlockName.ExtendedFilters);
  }, [houseInfo, dealType, estimation.data, estimationHistoryData, offersHistoryExists, preciseFiltersData]);
}
